import { CwtAppAuthBackground, CwtAppConfig } from "@mobile/modules/core/core-app.config";
import { ActivityTarget, AffinityStatus, InterestCategory } from "@shared/models";
import { environment } from "../../environments/environment";

export const KatchaAppConfig: CwtAppConfig = {
    userDefaultPicture: 'assets/img/default_user_picture.jpg',
    landingLogo: 'assets/img/logo_big.png',
    logoPicture: 'assets/img/logo.svg',
    webDomain: environment.webDomain,
    deeplink: { enable: true },
    layout: {
        headerLayout: 'extended',
        headerIcon: 'assets/img/logo_dark.svg',
        modalHeaderToolbarColor: 'primary',
    },
    stay: {
        useDates: true,
        projection: 'forStayStoreForUserApp',
        storageKey: 'cwt-katcha-last-partner',
        redirectOnPartnerActive: ['/home', 'feed'],
        redirectOnPartnerInactiveLoggedIn: ['/partner'],
        redirectOnPartnerInactiveLoggedOut: ['/auth', 'landing'],
        partnerSearchMode: 'code'
    },
    cards: {
        enable: true,
        defaultPicture: 'assets/img/default_enjoy_card_img.jpeg'
    },
    activities: {
        enable: true,
        defaultPicture: 'assets/img/default_activity_picture.jpg',
        canBookEvent: true,
        canRateEvent: true,
        showBookEventOnCard: true,
        showEventHost: true,
        forceAppIconOnEventHost: false,
        redirectOnCardClick: true,
        highlightPartnerEvents: true,
        activityTargets: [
            ActivityTarget.all,
            ActivityTarget.kid,
            ActivityTarget.adult
        ]
    },
    enjoyments: {
        enable: true,
        defaultPicture: 'assets/img/default_enjoy_card_img.jpeg'
    },
    prestations: {
        isClickableOnCustomerSpace: false
    },
    tips: {
        enable: true,
        defaultPicture: 'assets/img/default_discover_card_img.jpeg',
        redirectOnUrl: false,
        showFavorite: true
    },
    event: {
        useReservationDelay: true,
        maxCapacity: 12,
        targetPictures: {
            [ActivityTarget.kid]: 'assets/icon/for_kids.svg',
            [ActivityTarget.teen]: 'assets/icon/for_teens.svg',
            [ActivityTarget.adult]: 'assets/icon/for_adults.svg',
            [ActivityTarget.all]: 'assets/icon/for_all.svg'
        },
        eventWarningSubscription: false
    },
    partner: {
        defaultPicture: 'assets/img/logo.svg',
        defaultCardImage: 'assets/img/default_stay_card_img.jpeg',
        useLocations: true,
        showHomeCardOverlayToolbar: true,

        customizableElements: {
            discover: {
                redirectUrl: ['/tip'],
                defaultTitle: 'default-settings.discover-card-label',
                defaultPicture: 'assets/img/default_discover_card_img.jpeg',
            },
            enjoy: {
                redirectUrl: ['/enjoyment'],
                defaultTitle: 'default-settings.enjoy-card-label',
                defaultPicture: 'assets/img/default_enjoy_card_img.jpeg',
            },
            stay: {
                redirectUrl: ['/home', 'info'],
                queryParams: { showBackButton: true },
                defaultTitle: 'default-settings.stay-card-label',
                defaultPicture: 'assets/img/default_stay_card_img.jpeg',
            }
        },
        searchCriteria: 'search',
        useConversation: true,
        useCustomerSpace: true,
        useClientSpace: false,
        useInventory: true,
        useNotification: true,
        maxPicturePerInventoryReport: 5,
        showPartnerLogoInList: true,
    },
    auth: {
        backgrounds: {
            [CwtAppAuthBackground.Landing]: 'assets/img/landing_bg.jpg',
            [CwtAppAuthBackground.Login]: 'assets/img/landing_bg.jpg',
            [CwtAppAuthBackground.Register]: 'assets/img/register_bg.jpg',
            [CwtAppAuthBackground.ForgotPassword]: 'assets/img/landing_bg.jpg',
            [CwtAppAuthBackground.ResetPassword]: 'assets/img/landing_bg.jpg',
            [CwtAppAuthBackground.EmailValidation]: 'assets/img/landing_bg.jpg',
        },
        landingRoute: ['/auth', 'landing'],
        loginRoute: ['/auth', 'login'],
        registerRoute: ['/auth', 'register'],
        forgotPasswordRoute: ['/auth', 'forgot-password'],
        useLogin: true,
    },
    misc: {
        useUserImageFix: true,
        userImagePath: environment.customImageUrl
    },
    affinity: {
        useAffinityFields: true,
        affinityStatusPictures: {
            [AffinityStatus.FlashedMe]: 'assets/icon/flashed.svg',
            [AffinityStatus.Katched]: 'assets/icon/katched.svg',
            [AffinityStatus.Blocked]: 'assets/icon/blocked.svg'
        },
        interestCategoryPictures: {
            [InterestCategory.Culture]: 'assets/icon/interest_culture.svg',
            [InterestCategory.Food]: 'assets/icon/interest_food.svg',
            [InterestCategory.Leisure]: 'assets/icon/interest_leisure.svg',
            [InterestCategory.Sport]: 'assets/icon/interest_sport.svg',
            [InterestCategory.Camping]: 'assets/icon/interest_camping.svg',
        }
    }
}